import * as React from 'react';

function SvgSelectDate(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="select_date_svg__select_date"
      width={20.333}
      height={20.333}
      {...props}
    >
      <defs>
        <style>{'.select_date_svg__cls-1{fill:#fff}'}</style>
      </defs>
      <g id="select_date_svg__Group_80" data-name="Group 80">
        <g id="select_date_svg__Group_79" data-name="Group 79">
          <path
            id="select_date_svg__Path_167"
            d="M17.951 1.589H17V0h-1.591v1.589H4.924V0H3.336v1.589h-.953A2.386 2.386 0 000 3.971v13.98a2.386 2.386 0 002.383 2.383h15.568a2.386 2.386 0 002.383-2.383V3.971a2.386 2.386 0 00-2.383-2.382zm.794 16.362a.8.8 0 01-.794.794H2.383a.8.8 0 01-.794-.794V7.466h17.156zm0-12.073H1.589V3.971a.8.8 0 01.794-.794h.953v1.589h1.588V3.177h10.485v1.589H17V3.177h.953a.8.8 0 01.794.794z"
            className="select_date_svg__cls-1"
            data-name="Path 167"
          />
        </g>
      </g>
      <g id="select_date_svg__Group_82" data-name="Group 82" transform="translate(3.018 9.134)">
        <g id="select_date_svg__Group_81" data-name="Group 81">
          <path
            id="select_date_svg__Rectangle_261"
            d="M0 0h1.589v1.589H0z"
            className="select_date_svg__cls-1"
            data-name="Rectangle 261"
          />
        </g>
      </g>
      <g id="select_date_svg__Group_84" data-name="Group 84" transform="translate(6.195 9.134)">
        <g id="select_date_svg__Group_83" data-name="Group 83">
          <path
            id="select_date_svg__Rectangle_262"
            d="M0 0h1.589v1.589H0z"
            className="select_date_svg__cls-1"
            data-name="Rectangle 262"
          />
        </g>
      </g>
      <g id="select_date_svg__Group_86" data-name="Group 86" transform="translate(9.372 9.134)">
        <g id="select_date_svg__Group_85" data-name="Group 85">
          <path
            id="select_date_svg__Rectangle_263"
            d="M0 0h1.589v1.589H0z"
            className="select_date_svg__cls-1"
            data-name="Rectangle 263"
          />
        </g>
      </g>
      <g id="select_date_svg__Group_88" data-name="Group 88" transform="translate(12.55 9.134)">
        <g id="select_date_svg__Group_87" data-name="Group 87">
          <path
            id="select_date_svg__Rectangle_264"
            d="M0 0h1.589v1.589H0z"
            className="select_date_svg__cls-1"
            data-name="Rectangle 264"
          />
        </g>
      </g>
      <g id="select_date_svg__Group_90" data-name="Group 90" transform="translate(15.727 9.134)">
        <g id="select_date_svg__Group_89" data-name="Group 89">
          <path
            id="select_date_svg__Rectangle_265"
            d="M0 0h1.589v1.589H0z"
            className="select_date_svg__cls-1"
            data-name="Rectangle 265"
          />
        </g>
      </g>
      <g id="select_date_svg__Group_92" data-name="Group 92" transform="translate(3.018 12.311)">
        <g id="select_date_svg__Group_91" data-name="Group 91">
          <path
            id="select_date_svg__Rectangle_266"
            d="M0 0h1.589v1.589H0z"
            className="select_date_svg__cls-1"
            data-name="Rectangle 266"
          />
        </g>
      </g>
      <g id="select_date_svg__Group_94" data-name="Group 94" transform="translate(6.195 12.311)">
        <g id="select_date_svg__Group_93" data-name="Group 93">
          <path
            id="select_date_svg__Rectangle_267"
            d="M0 0h1.589v1.589H0z"
            className="select_date_svg__cls-1"
            data-name="Rectangle 267"
          />
        </g>
      </g>
      <g id="select_date_svg__Group_96" data-name="Group 96" transform="translate(9.372 12.311)">
        <g id="select_date_svg__Group_95" data-name="Group 95">
          <path
            id="select_date_svg__Rectangle_268"
            d="M0 0h1.589v1.589H0z"
            className="select_date_svg__cls-1"
            data-name="Rectangle 268"
          />
        </g>
      </g>
      <g id="select_date_svg__Group_98" data-name="Group 98" transform="translate(12.55 12.311)">
        <g id="select_date_svg__Group_97" data-name="Group 97">
          <path
            id="select_date_svg__Rectangle_269"
            d="M0 0h1.589v1.589H0z"
            className="select_date_svg__cls-1"
            data-name="Rectangle 269"
          />
        </g>
      </g>
      <g id="select_date_svg__Group_100" data-name="Group 100" transform="translate(3.018 15.488)">
        <g id="select_date_svg__Group_99" data-name="Group 99">
          <path
            id="select_date_svg__Rectangle_270"
            d="M0 0h1.589v1.589H0z"
            className="select_date_svg__cls-1"
            data-name="Rectangle 270"
          />
        </g>
      </g>
      <g id="select_date_svg__Group_102" data-name="Group 102" transform="translate(6.195 15.488)">
        <g id="select_date_svg__Group_101" data-name="Group 101">
          <path
            id="select_date_svg__Rectangle_271"
            d="M0 0h1.589v1.589H0z"
            className="select_date_svg__cls-1"
            data-name="Rectangle 271"
          />
        </g>
      </g>
      <g id="select_date_svg__Group_104" data-name="Group 104" transform="translate(9.372 15.488)">
        <g id="select_date_svg__Group_103" data-name="Group 103">
          <path
            id="select_date_svg__Rectangle_272"
            d="M0 0h1.589v1.589H0z"
            className="select_date_svg__cls-1"
            data-name="Rectangle 272"
          />
        </g>
      </g>
      <g id="select_date_svg__Group_106" data-name="Group 106" transform="translate(12.55 15.488)">
        <g id="select_date_svg__Group_105" data-name="Group 105">
          <path
            id="select_date_svg__Rectangle_273"
            d="M0 0h1.589v1.589H0z"
            className="select_date_svg__cls-1"
            data-name="Rectangle 273"
          />
        </g>
      </g>
      <g id="select_date_svg__Group_108" data-name="Group 108" transform="translate(15.727 12.311)">
        <g id="select_date_svg__Group_107" data-name="Group 107">
          <path
            id="select_date_svg__Rectangle_274"
            d="M0 0h1.589v1.589H0z"
            className="select_date_svg__cls-1"
            data-name="Rectangle 274"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgSelectDate;
